/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FolderXIcon16Light } from './FolderXIcon16Light';
import { FolderXIcon16Regular } from './FolderXIcon16Regular';
import { FolderXIcon16Solid } from './FolderXIcon16Solid';
import { FolderXIcon20Light } from './FolderXIcon20Light';
import { FolderXIcon20Regular } from './FolderXIcon20Regular';
import { FolderXIcon20Solid } from './FolderXIcon20Solid';
import { FolderXIcon24Regular } from './FolderXIcon24Regular';
import { FolderXIcon24Solid } from './FolderXIcon24Solid';
import { FolderXIcon32Regular } from './FolderXIcon32Regular';
import { FolderXIcon64Regular } from './FolderXIcon64Regular';
var sizes = {
    16: {
        light: FolderXIcon16Light,
        regular: FolderXIcon16Regular,
        solid: FolderXIcon16Solid,
    },
    20: {
        light: FolderXIcon20Light,
        regular: FolderXIcon20Regular,
        solid: FolderXIcon20Solid,
    },
    24: {
        regular: FolderXIcon24Regular,
        solid: FolderXIcon24Solid,
    },
    32: {
        regular: FolderXIcon32Regular,
    },
    64: {
        regular: FolderXIcon64Regular,
    },
};
export var FolderXIcon = forwardRef('FolderXIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
